import { FxIcon } from '@/components/fx'

import { JobsPanel, SystemPanel } from './verwaltung'

/**
 * The "Verwaltung" tab: what used to be the separate admin portal, minus the
 * parts that were never worth a screen — its Dashboard's four stat tiles and
 * its "Phase 2 Complete!" development banner are gone, and the API-Zugang half
 * of that portal now lives in its own tab, visible to everyone, because API
 * keys are per account and not an administrator's privilege.
 *
 * Only administrators are routed here; the check and the route gate belong to
 * `SettingsPage`. The line below is a statement of that fact for the person
 * reading the screen, not a second gate.
 *
 * The 360px column beside a fluid one is the settings-tab idiom (see
 * `BillingSettings`): the system's health is a fixed, scannable list, and the
 * job table is the part that wants whatever width is left. Below `md` they
 * stack, health first — it answers "is anything wrong at all?" before the
 * table says which job it was.
 */
export function VerwaltungSection() {
  return (
    <div className="flex flex-col gap-8">
      <p className="flex items-center gap-2 text-small text-text-muted">
        <FxIcon name="shield_person" size={18} />
        Dieser Bereich ist nur für Administrator:innen sichtbar.
      </p>

      <div className="grid grid-cols-1 items-start gap-7 md:grid-cols-[360px_minmax(0,1fr)]">
        <SystemPanel />
        <JobsPanel />
      </div>
    </div>
  )
}
